import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {sortArrayByProperty, shuffleArray} from 'helpers/array-helper';
import {sortPoints} from 'data/points-data';
import Sort from './sort';

class SortController extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			isPaused: false,
			animation: null,
			sortData: null,
			selectedItemIndex: null
		};
		this.timeout = null;
	}

	/**
	 * Component mounted
	 */
	componentDidMount = () => {
		/* Load challenge */
		this.loadChallenge();
	};

	/**
	 * Component updated
	 * @param {object} prevProps
	 */
	componentDidUpdate = (prevProps) => {
		if (this.props.challengeData.id !== prevProps.challengeData.id) {
			this.setState({isLoading: true, sortData: null}, () => {this.loadChallenge();});
		}
	};

	/**
	 * Load sort & sync with player
	 */
	loadChallenge = () => {
		/* Get sort data */
		let challengeData = JSON.parse(JSON.stringify(this.props.challengeData));
		challengeData.completed = false;
		challengeData.errors = 0;

		/* Sort / shuffle items */
		if (challengeData.hasOwnProperty('sortItems') && challengeData.sortItems === true) {
			challengeData.items = sortArrayByProperty(challengeData.items, 'id', 'ASC');
		} else {
			challengeData.items = shuffleArray(challengeData.items);
		}
		

		/* Sync with player progress */
		if (
			this.props.playerData.hasOwnProperty('challenges') &&
				this.props.playerData.challenges.some((challenge) => {return challenge.id === challengeData.id;})
		) {
			let playerChallengeData = this.props.playerData.challenges.filter((challenge) => {
				return challenge.id === challengeData.id;
			})[0];
			if (playerChallengeData.hasOwnProperty('completed')) {
				challengeData.completed = playerChallengeData.completed;
			}
			challengeData.errors = playerChallengeData.errors;
			challengeData.items.forEach((item) => {
				if (playerChallengeData.sortedItems.indexOf(item.id) >= 0) {
					item.isPlaced = true;
				}
			});
		}

		/* Update state */
		this.setState({isLoading: false, isPaused: challengeData.completed, sortData: challengeData}, () => {
			/* Adjust body height */
			// let headerElement = document.getElementById('SortHeader');
			// let bodyElement = document.getElementById('SortBody');
			// if (headerElement && bodyElement) {
			// 	let fontSize = 16 * ((headerElement.clientWidth / 360));
			// 	let headerHeight = headerElement.clientHeight + (2.5 * fontSize);
			// 	bodyElement.style.paddingTop = headerHeight + 'px';
			// }
		});
	};

	/**
	 * Select item
	 * @param {number} itemIndex
	 */
	handleSelectItem = (itemIndex) => {
		if (this.state.isPaused) return;

		this.setState({isPaused: true}, () => {
			let selectedItemIndex = (this.state.selectedItemIndex === itemIndex ? null : itemIndex);
			this.setState({isPaused: false, selectedItemIndex});
		});
	};

	/**
	 * Select box
	 * @param {string} boxId
	 */
	handleSelectBox = (boxId) => {
		if (this.state.isPaused || this.state.selectedItemIndex === null) return;

		this.setState({isPaused: true}, () => {
			let challengeData = JSON.parse(JSON.stringify(this.state.sortData));
			let isCorrect = (challengeData.items[this.state.selectedItemIndex].correctBoxId === boxId);
			
			/* Update game data */
			if (!isCorrect) {
				/* Wrong placement */
				challengeData.errors = challengeData.errors + 1;
				this.setState({animation: 'wrong', sortData: challengeData});
			/* Correct placement */
			} else {
				challengeData.items[this.state.selectedItemIndex].isPlaced = true;
				this.setState({animation: 'correct', sortData: challengeData});
			}
			/* Player data - progress and errors */
			let playerChallenges = [];
			let sortedItems = [];
			challengeData.items.forEach((item) => {
				if (item.isPlaced) sortedItems.push(item.id);
			});
			if (this.props.playerData.hasOwnProperty('challenges')) {
				playerChallenges = JSON.parse(JSON.stringify(this.props.playerData.challenges));
			}
			let playerChallengeIndex = playerChallenges.findIndex((challenge) => {
				return challenge.id === challengeData.id;
			});
			if (playerChallengeIndex === -1) {
				playerChallenges.push({
					id: challengeData.id, completed: false, errors: challengeData.errors, sortedItems: sortedItems
				});
			} else {
				playerChallenges[playerChallengeIndex].errors = challengeData.errors;
				playerChallenges[playerChallengeIndex].sortedItems = sortedItems;
			}

			/* Player data - points */
			let playerPoints = this.props.playerData.hasOwnProperty('points') 
				? JSON.parse(JSON.stringify(this.props.playerData.points))
				: 0;

			/* Update player data */
			this.props.updatePlayerData({
				challenges: playerChallenges,
				points: playerPoints
			}).then((response) => {
				if (response.status === 'ok') {
					this.timeout = setTimeout(() => {
						/* Check if all items have been sorted */
						let challengeIsComplete = 
							!challengeData.items.some((item) => {return item.isPlaced === false;});
						
						if (challengeIsComplete) {
							/* Update game state, handle challenge completed */
							this.setState({selectedItemIndex: null, animation: null});
							this.sortingCompleted();
						} else {
							/* Update game state, show streak popup */
							this.setState({isPaused: false, selectedItemIndex: null, animation: null});
						}
					}, 500);
				} else {
					console.error('error', response);
				}
			});
		});
	};

	/**
	 * Sorting completed
	 */
	sortingCompleted = () => {
		let challengeData = JSON.parse(JSON.stringify(this.state.sortData));
		challengeData.completed = true;

		let points = sortPoints.minPoints;
		let pointIndex = sortPoints.pointLimits.findIndex((limit) => {return challengeData.errors <= limit;});
		if (pointIndex >= 0) points = sortPoints.pointValues[pointIndex];
		
		this.props.completeChallenge(challengeData.id, points).then(() => {
			this.setState({sortData: challengeData});
		});
	};

	/**
	 * Render component
	 */
	render = () => {
		if (!this.state.isLoading && this.state.sortData) {
			return (
				<Sort
					isPaused={this.state.isPaused}
					selectedItemIndex={this.state.selectedItemIndex}
					animation={this.state.animation}
					sortData={this.state.sortData}
					handleSelectItem={this.handleSelectItem}
					handleSelectBox={this.handleSelectBox}
				/>
			);
		}
		return null;
	};
}

SortController.propTypes = {
	challengeData: PropTypes.object.isRequired,
	playerData: PropTypes.object.isRequired,
	updatePlayerData: PropTypes.func.isRequired,
	completeChallenge: PropTypes.func.isRequired
};

export default SortController;